/**
 * Canonical security category taxonomy shared across incidents and investigations.
 * Derived from NIST IR taxonomy + physical-security operations (VIS-114).
 *
 * The order of the array is the canonical display order for all forms, filters,
 * and dropdowns across the platform.
 */

export const SECURITY_CATEGORIES = [
  'Cyber',
  'Physical',
  'Personnel',
  'Compliance',
  'Facilities',
  'Emergency Response',
  'Workplace Violence',
  'Other',
] as const;

export type SecurityCategory = (typeof SECURITY_CATEGORIES)[number];

/**
 * Stable color palette pinned to each canonical category.
 * Used by analytics charts, badges, and any UI that renders categories visually.
 */
export const CATEGORY_COLORS: Record<SecurityCategory, string> = {
  Cyber: '#3B82F6',               // Blue
  Physical: '#EF4444',            // Red
  Personnel: '#F59E0B',           // Amber
  Compliance: '#8B5CF6',          // Violet
  Facilities: '#06B6D4',          // Cyan
  'Emergency Response': '#F97316', // Orange
  'Workplace Violence': '#EC4899', // Pink
  Other: '#6B7280',               // Gray
};

/**
 * Maps each canonical category to one of the 4 risk-posture domains
 * used by the analytics risk-posture service.
 */
export const CATEGORY_TO_RISK_DOMAIN: Record<SecurityCategory, string> = {
  Cyber: 'Cyber',
  Physical: 'Physical',
  Personnel: 'Insider',
  Compliance: 'Compliance',
  Facilities: 'Physical',
  'Emergency Response': 'Physical',
  'Workplace Violence': 'Insider',
  Other: 'Other',
};
